<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1953"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1957"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1967"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path1965" /></clipPath></defs><g
     id="g1959"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g1961"><g
         id="g1963"
         clip-path="url(#clipPath1967)"><g
           id="g1969"
           transform="translate(477.9297,372.9502)"><path
             d="m 0,0 h 18.57 c 4.42,0 8,-3.59 8,-8 v -262.12"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1971" /></g><g
           id="g1973"
           transform="translate(102.48,372.9517)"><path
             d="M 0,0 H -26.18"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1975" /></g><g
           id="g1977"
           transform="translate(289.75,372.9517)"><path
             d="M 0,0 H -152.27"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1979" /></g><g
           id="g1981"
           transform="translate(504.5,67.8315)"><path
             d="m 0,0 v -23.41 c 0,-4.41 -3.58,-8 -8,-8 h -465 c -13.25,0 -24,10.75 -24,24 v 20.26"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1983" /></g><g
           id="g1985"
           transform="translate(7.5,80.686)"><path
             d="m 0,0 c 0,13.25 10.75,24 24,24 h 40.804 c 2.21,0 4,1.791 4,4 v 311.043 c 0,2.209 -1.79,4 -4,4 H 24 c -13.255,0 -24,-10.745 -24,-24 z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1987" /></g><g
           id="g1989"
           transform="translate(362.0596,347.2314)"><path
             d="m 0,0 c 7.971,-5.21 12.2,-5.79 21.271,-5.73 23.24,0.16 31.689,32.37 8.839,40.45 -3.21,1.14 -6.16,2.23 -8.839,3.33 -5.871,2.39 -10.521,4.76 -13.97,7.47 -8.771,6.88 -5.561,24.53 7.33,28.41 2.359,0.71 4.579,1.06 6.64,1.15 10.219,0.5 16.53,-5.32 16.53,-5.32"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1991" /></g><g
           id="g1993"
           transform="translate(383.3301,329.7417)"><path
             d="M 0,0 V 11.76"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1995" /></g><g
           id="g1997"
           transform="translate(383.3301,422.3115)"><path
             d="M 0,0 V 10.92"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1999" /></g><g
           id="g2001"
           transform="translate(477.9346,365.6792)"><path
             d="m 0,0 v 31.617 c 0,1.656 -1.343,3 -3,3 h -18.888 c -1.309,0 -2.483,0.843 -2.86,2.096 -1.403,4.663 -3.262,9.128 -5.527,13.343 -0.621,1.153 -0.389,2.58 0.538,3.507 L -16.38,66.92 c 1.171,1.171 1.171,3.071 0,4.243 l -22.356,22.356 c -1.172,1.171 -3.072,1.171 -4.243,0 L -56.337,80.162 c -0.926,-0.927 -2.352,-1.159 -3.507,-0.538 -4.214,2.265 -8.679,4.124 -13.342,5.527 -1.253,0.377 -2.096,1.551 -2.096,2.86 v 18.888 c 0,1.657 -1.344,3 -3,3 h -31.617 c -1.657,0 -3,-1.343 -3,-3 V 88.011 c 0,-1.309 -0.843,-2.483 -2.096,-2.86 -4.663,-1.403 -9.129,-3.262 -13.343,-5.527 -1.153,-0.621 -2.581,-0.389 -3.507,0.538 l -13.357,13.357 c -1.172,1.171 -3.071,1.171 -4.242,0 l -22.357,-22.356 c -1.172,-1.172 -1.172,-3.072 0,-4.243 l 13.358,-13.357 c 0.925,-0.927 1.157,-2.354 0.537,-3.507 -2.266,-4.215 -4.124,-8.68 -5.528,-13.343 -0.377,-1.253 -1.55,-2.096 -2.859,-2.096 h -18.889 c -1.656,0 -3,-1.344 -3,-3 V 0 c 0,-1.657 1.344,-3 3,-3 h 18.889 c 1.309,0 2.482,-0.843 2.859,-2.096 1.404,-4.663 3.262,-9.128 5.528,-13.342 0.62,-1.154 0.388,-2.582 -0.537,-3.508 l -13.358,-13.357 c -1.172,-1.172 -1.172,-3.071 0,-4.242 l 22.357,-22.357 c 1.171,-1.172 3.07,-1.172 4.242,0 l 13.357,13.358 c 0.926,0.925 2.354,1.157 3.507,0.537 4.215,-2.265 8.68,-4.124 13.343,-5.527 1.253,-0.378 2.096,-1.551 2.096,-2.86 v -18.888 c 0,-1.657 1.343,-3 3,-3 h 31.617 c 1.656,0 3,1.343 3,3 v 18.888 c 0,1.309 0.843,2.482 2.096,2.86 4.663,1.403 9.128,3.262 13.342,5.527 1.155,0.62 2.581,0.388 3.507,-0.537 l 13.358,-13.358 c 1.171,-1.172 3.071,-1.172 4.243,0 l 22.356,22.357 c 1.171,1.171 1.171,3.07 0,4.242 l -13.357,13.357 c -0.927,0.926 -1.159,2.354 -0.538,3.508 2.265,4.214 4.124,8.679 5.527,13.342 0.377,1.253 1.551,2.096 2.86,2.096 L -3,-3 c 1.657,0 3,1.343 3,3 z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2003" /></g><g
           id="g2005"
           transform="translate(410.4199,102.5518)"><path
             d="M 0,0 V 86.79"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2007" /></g><g
           id="g2009"
           transform="translate(226.7598,102.5518)"><path
             d="M 0,0 V 116.62"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2011" /></g><g
           id="g2013"
           transform="translate(258.7646,128.6387)"><path
             d="m 0,0 v 56.663 c 0,1.233 1.106,2.173 2.324,1.973 L 117.982,39.662 c 0.967,-0.159 1.677,-0.995 1.677,-1.974 V 0 c 0,-1.104 -0.895,-2 -2,-2 H 2 C 0.896,-2 0,-1.104 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2015" /></g><g
           id="g2017"
           transform="translate(419.9404,187.793)"><path
             d="m 0,0 -206.939,33.621 c -1.09,0.177 -1.831,1.204 -1.654,2.295 l 3.605,22.187 c 0.177,1.09 1.205,1.831 2.295,1.653 L 4.246,26.135 c 1.09,-0.177 1.83,-1.204 1.653,-2.294 L 2.295,1.653 C 2.117,0.563 1.09,-0.177 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2019" /></g><g
           id="g2021"
           transform="translate(236.7202,244.3916)"><path
             d="m 0,0 3.37,68.53 c 0.05,1.07 0.93,1.9 2,1.9 H 42.2 c 1.06,0 1.94,-0.83 1.99,-1.9 l 3.76,-76.32"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2023" /></g><g
           id="g2025"
           transform="translate(165.7202,102.5518)"><path
             d="M 0,0 V 63.8"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2027" /></g><g
           id="g2029"
           transform="translate(226.7598,166.3516)"><path
             d="m 0,0 h -69.82 c -1.11,0 -2,0.9 -2,2 v 22.48 c 0,1.1 0.89,2 2,2 H 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2031" /></g><g
           id="g2033"
           transform="translate(133.8804,102.5483)"><path
             d="M 0,0 H 313.043"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2035" /></g><g
           id="g2037"
           transform="translate(282.3604,283.5356)"><path
             d="M 0,0 H -43.71"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2039" /></g><g
           id="g2041"
           transform="translate(108.0435,340.8232)"><path
             d="M 0,0 H 64.435"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2043" /></g><g
           id="g2045"
           transform="translate(108.0435,314.8232)"><path
             d="M 0,0 H 54.435"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2047" /></g><g
           id="g2049"
           transform="translate(108.0435,288.8232)"><path
             d="M 0,0 H 41.479"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2051" /></g><g
           id="g2053"
           transform="translate(406.8262,73.749)"><path
             d="M 0,0 V -8.521"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2055" /></g><g
           id="g2057"
           transform="translate(432.8262,73.749)"><path
             d="M 0,0 V -8.521"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2059" /></g><g
           id="g2061"
           transform="translate(458.8262,73.749)"><path
             d="M 0,0 V -8.521"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2063" /></g></g></g></g></svg>
</template>
